module.exports = __webpack_public_path__ + "img/Almacen.2a1a6425.svg";